import { getDashboardUrl } from "@areahub/config";
import { useSession, UseSessionOptions } from "next-auth/react";
import { useRouter } from "next/navigation";

export function usePremiumRoutes(sessionOpts?: UseSessionOptions<boolean>) {
  const { data, status } = useSession(sessionOpts);
  const router = useRouter();
  if (status === "authenticated") {
    const user = data?.user as {
      name: string;
      email: string;
      image: string;
      type?: "PREMIUM" | "UNKNOWN" | "PRO_REPORT";
    };
    const redirectSuffix =
      user?.["type"] === "PREMIUM"
        ? "/subscriber"
        : user?.["type"] === "UNKNOWN"
        ? "/api/route-user"
        : "/pro-report";
    const redirectUrl = getDashboardUrl() + redirectSuffix;
    return {
      session: data,
      router,
      user,
      status,
      redirectUrl,
      redirectSuffix,
    };
  }
  return {
    session: data,
    status,
    router,
    user: undefined,
    redirectSuffix: "/api/route-user",
    redirectUrl: getDashboardUrl() + "/api/route-user",
  };
}
